// @flow
import * as React from 'react';
import { injectIntl } from 'react-intl';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

import { Button, Icon } from 'components/atoms/';
import SocialLoginContainer from 'components/pages/User/Social/SocialLogin/SocialLoginContainer';
import { isObjEmpty } from 'utils/varValidation';

import './CreateProfileSocial.scss';

type Props = {|
  /**
   * Callback invoked when the "sign up" component is clicked
   */
  onSignUpClick: (event: MouseEvent) => void,
  intl: IntlShape
|};

type State = {|
  errors: {
    /** True if the social login user is invalid */
    invalidUser?: boolean
  }
|};

class CreateProfileSocial extends React.Component<Props, State> {
  static block = 'create-profile-social';

  state = {
    errors: {}
  };

  resetErrors = () => {
    this.setState({ errors: {} });
  };

  onSocialLoginInvalidUser = () => {
    this.setState({
      errors: {
        invalidUser: true
      }
    });
  };

  onSignUpClick = (mouseEvent: MouseEvent) => {
    this.resetErrors();
    this.props.onSignUpClick(mouseEvent);
  };

  render() {
    const { intl } = this.props;
    const cn = CreateProfileSocial.block;
    const hasErrors = !isObjEmpty(this.state.errors);
    return (
      <div className={cn}>
        <h1 className={`${cn}__title`}>
          {intl.formatMessage({ id: 'c8.common.create.profile' })}
        </h1>
        <p>
          {intl.formatMessage({
            id:
              'c8.confirmation.modal.create.profile.save.time.and.let.us.help.you.maintain.your.vehicle'
          })}
        </p>
        <div className={`${cn}__with-social`}>
          <p>
            {intl.formatMessage({
              id: 'c8.confirmation.modal.create.profile.create.profile.with'
            })}
          </p>
          <SocialLoginContainer
            onButtonClick={this.resetErrors}
            onInvalidUser={this.onSocialLoginInvalidUser}
          />
          <p className={`${cn}__error`}>
            {this.state.errors.invalidUser &&
              'Something went wrong using Facebook'}
            {/* placeholder */}
            {!hasErrors && <span>&nbsp;</span>}
          </p>
        </div>
        <p aria-disabled={true}>
          {intl.formatMessage({
            id:
              'c8.confirmation.modal.create.profile.i.do.not.want.to.use.google'
          })}
        </p>
        <div className={`${cn}__sign-up`} onClick={this.onSignUpClick}>
          <div>
            <Button
              buttonTheme="link"
              className="text-uppercase"
              tabIndex={0}
              aria-label={intl.formatMessage({
                id: 'c8.aria.common.create.profile',
                defaultMessage: 'Create User Profile'
              })}
            >
              {intl.formatMessage({ id: 'c8.common.sign.up' })}
            </Button>
          </div>
          <div>
            <Icon type="chevron__down" />
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(CreateProfileSocial);



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/CreateProfile/components/CreateProfileSocial/CreateProfileSocial.js